import React, { useRef, useEffect, useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { LocalShipping } from '@material-ui/icons';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';

import api from '~/services/api';
import { toast } from 'react-toastify';
import { get, isEmpty } from 'lodash';
import { ADM, GFE } from '~/constants/perfil';
import { UnidataTable } from '~/components';
import { recordFiltering } from '~/store/modules/operacaopostocontrolesiad/actions';

import EditarPosto from './components/EditarPosto';

import HabilitarIntegracao from './components/HabilitarIntegracao';

import { Container } from './styles';

function OperacaoPostoControleSiadList() {
  const dispatch = useDispatch();

  const [habEditarPosto, setHabEditarPosto] = useState(false);

  const [modoIntegracaoSIAD, setModoIntegracaoSIAD] = useState(999);

  const [atualizaStatusSIAD, setAtualizaStatusSIAD] = useState(false);

  const [isGfeC, setIsGfeC] = useState(false);

  const { profile } = useSelector((state) => state.user);


  const operacaopostocontrolesiad = useSelector(
    (state) => state.operacaopostocontrolesiad
  );

  const editarPostoRef = useRef(null);

  const habilitarIntegracaoRef = useRef(null);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      async function getConfigSistema() {
        try {
          const response = await api.get(`/configsistema`);
          const statusRetorno = get(
            response,
            'data.cosi_consul_libera_abast_siad',
            ''
          );
          if (String(statusRetorno) === '') {
            toast.error('Não foi possível fazer a consulta!');
            return;
          }
          if (response && !isEmpty(response.data)) {
            if (String(response.data.cosi_consul_libera_abast_siad) !== '1') {
              setModoIntegracaoSIAD(0);
            } else {
              setModoIntegracaoSIAD(1);
            }
          }
        } catch (err) {
          setModoIntegracaoSIAD(0);
          toast.error(` ${err} `);
        }
      }
      getConfigSistema();
    }
    return function cleanup() {
      mounted = false;
    };
  }, [atualizaStatusSIAD]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (profile.gloperfilid == 67) {
        setIsGfeC(true)
      }
      switch (profile.glousuariotipo) {
        case ADM:
          setHabEditarPosto(true);
          break;
        case GFE:
          if (profile.gloperfilid != 67)
            setHabEditarPosto(true);
          break;
        default:
          setHabEditarPosto(false);
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  const handleUpdateBaseSiad = React.useCallback(async () => {
    await setAtualizaStatusSIAD(!atualizaStatusSIAD);
  }, [atualizaStatusSIAD]);

  const handleUpdate = React.useCallback(async () => {
    await dispatch(recordFiltering(operacaopostocontrolesiad.params));
  }, [operacaopostocontrolesiad.params]);

  const header = useMemo(
    () => [
      {
        id: 'poco_descricao',
        label: 'Posto',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'posto_modo_operacao',
        label: 'Modo Operação',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'poco_abastec_modo_site_str',
        label: 'Modo Abastecimento',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'poco_interface_siad_str',
        label: 'Integração Habilitada',
        filter: {
          type: 'text',
        },
        styled: (value) =>
          value === 'Sim' ? { color: '#ff0000' } : { color: '#00B300' },
        align: 'left',
      },
    ],
    []
  );

  const headerhabEditarPosto = useMemo(
    () => {
      let buttons = []
      if (habEditarPosto) {
        buttons.push({
          title: 'Editar Posto',
          action: (value) => editarPostoRef.current.handleToggleModal(value),
          icon: <LocalShipping />,
        })
      }

      return buttons;

    }
    ,
    [habEditarPosto]
  );

  useEffect(() => {

  }, [])

  return (
    <>
      <Container>
        <Button
          variant="contained"
          color="primary"
          onClick={(modoIntegracaoSIAD) =>
            habilitarIntegracaoRef.current.handleToggleModal(modoIntegracaoSIAD)
          }
          disabled={isGfeC}
        >
          Habilitar/Desabilitar Integração Total SIAD
        </Button>

        {isGfeC ? ''
          : modoIntegracaoSIAD === 1 ? (
            <Alert severity="success">Modo de integração SIAD Ativada!</Alert>
          ) : modoIntegracaoSIAD === 0 ? (
            <Alert severity="error">Modo de integração SIAD Desativada!</Alert>
          ) : (
            ''
          )}
      </Container>

      <UnidataTable
        pdf
        excel
        reportOrder="poco_codigo ASC"
        title={'Posto Interface SIAD'}
        create={false}
        delete={false}
        update={false}
        fixed
        header={header}
        redux={operacaopostocontrolesiad}
        read={recordFiltering}
        actions={headerhabEditarPosto}
        detach="poco_codigo"
        keys="poco_codigo"
        view="VW_POSTO"
        reportTitle="Posto Interface SIAD"
      />

      <EditarPosto
        ref={editarPostoRef}
        update={() => handleUpdate()}
        name="EditarPosto"
      />

      <HabilitarIntegracao
        ref={habilitarIntegracaoRef}
        update={() => handleUpdateBaseSiad()}
        name="HabilitarIntegracao"
      />
    </>
  );
}

export default OperacaoPostoControleSiadList;
